import { createEventDefinition } from 'ts-bus';
import { WidgetProps } from '../../types';

export const registerWidgetEvent = createEventDefinition<WidgetProps>()(
  'REGISTER_WIDGET'
);

export const updateWidgetEvent = createEventDefinition<WidgetProps>()(
  'UPDATE_WIDGET'
);

export const publishWidgetEvent = createEventDefinition<{}>()('PUBLISH_WIDGET');
